export default __webpack_public_path__ + "static/media/496.4be730a6.gif";